import { ContentApiContentUpdateRequest } from "../../openapi/api";
import appApiClient from "./coreApiClient";
import useBaseMutation from "./useBaseMutation";

export const useContentUpdateMutation = () =>
  useBaseMutation({
    mutationFn: (req: ContentApiContentUpdateRequest, config) =>
      appApiClient.contentApi.contentUpdate(req, config),
  });
